const namespace = 'jobpro/scheduler/modals/settingsModal';
const CLOSE = `${namespace}/CLOSE`;
const OPEN = `${namespace}/OPEN`;

// Default state
const DEFAULT_STATE = {
  show: false
};

// Reducer
export default function (state = DEFAULT_STATE, { payload, type }) {
  switch (type) {
    case CLOSE:
      return DEFAULT_STATE;
    case OPEN:
      return {
        ...state,
        show: true
      };
    default:
      return state;
  }
}

// Action creators
export const close = () => ({
  type: CLOSE
});

export const open = () => ({
  type: OPEN
});
